import { Navigate, Route, Routes } from "react-router-dom";
import AdminPage from "src/components/pages/admin/admin";
import HomePage from "src/components/pages/home/home";
import GapPage from "src/components/pages/gap/gap";
import RegionPreferencesPage from "src/components/pages/changeRegion/changeRegion";
import HelpAndSupportPage from "src/components/pages/helpAndSupport/helpAndSupport";
import { useAppSelector } from "src/store/store";
import ConversationDetail from "src/components/pages/admin/conversationDetail";
import ConversationList from "src/components/pages/admin/conversationsList";
import AdminOverview from "src/components/pages/admin/adminReport/overview";
import AdminDocumentsList from "src/components/pages/admin/adminReport/documentsList";
import AdminDocumentDetail from "src/components/pages/admin/adminReport/documentDetail";
import AdminFailedCases from "src/components/pages/admin/adminReport/failedCases";
import Unauthorized from "src/components/routes/unauthorized";
import { isBetaOrLocalEnv } from "src/utils/detectEnv";

const MainContent = () => {
  const { token, isAuthorized, isAdministrator } = useAppSelector(
    (state) => state.user,
  );

  return (
    <div className="main">
      {!token || !isAuthorized ? (
        <Unauthorized />
      ) : (
        <Routes>
          {/* Home Route: Renders HomePage component when path is exactly "/" */}
          <Route path="/" element={<HomePage />} />

          {/* Saige Route: Renders HomePage component while keeping /saige URL */}
          <Route path="/saige" element={<HomePage />} />

          {/* Mcp Route: Renders HomePage component with mcp feature */}
          <Route path="/mcp" element={<HomePage />} />

          {/* Gap Route: Renders GapPage component for document analysis */}
          <Route path="/gap" element={<GapPage />} />

          {/* Region Preferences Route */}
          <Route path="/change-region" element={<RegionPreferencesPage />} />

          {/* Admin Route: Only rendered if isAdministrator is true*/}
          {isAdministrator && (
            <Route path="/admin" element={<AdminPage />}>
              {/* Beta lands on the report; gamma and prod keep the old view */}
              <Route
                index
                element={
                  isBetaOrLocalEnv() ? (
                    <Navigate to="/admin/overview" replace />
                  ) : (
                    <ConversationList />
                  )
                }
              />

              {/* Admin Report, beta and local only */}
              {isBetaOrLocalEnv() && (
                <>
                  <Route path="overview" element={<AdminOverview />} />
                  <Route path="documents" element={<AdminDocumentsList />} />
                  <Route
                    path="documents/:attachmentId"
                    element={<AdminDocumentDetail />}
                  />
                  <Route path="failures" element={<AdminFailedCases />} />
                </>
              )}

              {/* Registered in every stage: the conversation table links here */}
              <Route path="conversations" element={<ConversationList />} />
              <Route
                path="conversations/:conversationId"
                element={<ConversationDetail />}
              />

              {/* Kept so links shared before the tabs existed still resolve */}
              <Route path=":conversationId" element={<ConversationDetail />} />
            </Route>
          )}

          {/* Help and Support Route */}
          <Route path="/help-and-support" element={<HelpAndSupportPage />} />

          {/* Catch-all Route: Handles any undefined routes
              The "*" matches any route not defined above
              Navigate component redirects to home page */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      )}
    </div>
  );
};

export default MainContent;
